import DealStagesFragments from 'features/deals/DealStages/fragments';

import { gql } from '@apollo/client';

export const SAVE_SELLER_BID = gql`
  mutation SaveSellerBid($input: SaveSellerBidInput!) {
    saveSellerBid(input: $input) {
      id
      ...DealStagesDeal
    }
  }
  ${DealStagesFragments.Deal}
`;
